<template>
    <Modal>
        <form method="post" class="p-grid p-fluid p-justify-end">

            <AutoComplete v-model="selectedValue"
                          field="label"
                          class="p-col-12"
                          :suggestions="filtered"
                          @complete="searchUsers($event)"
                          :placeholder="this.$t('loginAs')"
                          :dropdown="true"/>

            <div class="p-col-6">
                <Button
                        id="continue"
                        style="margin-top: 4em;"
                        :label="this.$t('continue')"
                        @click="onSubmit()"/>
            </div>
        </form>
    </Modal>
</template>

<script>
    import urljoin from 'url-join';
    import Modal from "../Shared/Modal";
    import Button from "primevue/button";
    import OrganizationService from "../../service/OrganizationService";
    import {JwtToken} from "@/utils/jwt";
    import axios from "axios";

    export default {
        components: {
            Modal,
            Button
        },
        data() {
            return {
                options: [],
                loading: true,
                filtered: null,
                selectedValue: null
            };
        },
        service: null,
        created() {
            this.service = new OrganizationService();
        },
        mounted() {
            this.service.getOrganizationTree()
                .then(result => result.data)
                .then(organizations => {
                    this.loading = false;

                    let currentOrgId = JwtToken.fromLocalStorage().organizationId();
                    let queue = organizations;

                    while (queue.length) {
                        const item = queue.pop();

                        const option = {
                          id: item.id,
                          label: item.name
                        };

                        if (option.id === currentOrgId) {
                          option.label += ` [${this.$t('currentlyLoggedInAs')}]`;
                        }

                        this.options.push(option);

                        if (item.subsidiaries) {
                            queue = queue.concat(item.subsidiaries);
                        }
                    }

                    this.options.sort((one, another) => one.label.localeCompare(another.label));
                });
        },
        methods: {
            searchUsers: function (event) {

                if (this.loading) {
                    setTimeout(() => this.searchUsers(event));
                    return;
                }

                setTimeout(() => {

                    const query = event.query.toLowerCase();

                    this.filtered = this.options.filter(record => record.label.toLowerCase().includes(query));
                }, 250);
            },
            onSubmit: function () {
                if (this.selectedValue) {
                    axios.post(`/api/v4/auth/organizations/${this.selectedValue.id}`)
                        .then(response => {
                            localStorage.setItem('access_token', response.data.accessToken);
                            localStorage.setItem('refresh_token', response.data.refreshToken);
                            location.href = urljoin(
                                "/sso",
                                `?refresh_token=${response.data.refreshToken}`,
                                `?access_token=${response.data.accessToken}`
                            );
                        });
                } else {
                    location.href = this.$route.query.continue;
                }
            }
        }
    }
</script>

<i18n lang="yaml" locale="en">
    loginAs: "Choose company to view for"
    currentlyLoggedInAs: "currently logged in"
</i18n>
